import { render, staticRenderFns } from "./KplaySpribe.vue?vue&type=template&id=54b6f1d2&scoped=true"
import script from "./KplaySpribe.vue?vue&type=script&lang=js"
export * from "./KplaySpribe.vue?vue&type=script&lang=js"
import style0 from "./KplaySpribe.vue?vue&type=style&index=0&id=54b6f1d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b6f1d2",
  null
  
)

export default component.exports